import type { ReactNode } from 'react';
import cx from 'clsx';
import { IconArrowLeftOutlined, IconArrowRightOutlined } from '@repo/monochrome-icons';
import { useIntl } from 'react-intl';
import styles from './attachment-viewer-nav.module.css';

const ARROW_CONFIG = {
  prev: {
    positionClassName: styles.arrowLeft,
    Icon: IconArrowLeftOutlined,
  },
  next: {
    positionClassName: styles.arrowRight,
    Icon: IconArrowRightOutlined,
  },
} as const;

type AttachmentViewerNavDirection = keyof typeof ARROW_CONFIG;

interface AttachmentViewerNavArrowProps {
  direction: AttachmentViewerNavDirection;
  onClick: () => void;
}

export function AttachmentViewerNavArrow({
  direction,
  onClick,
}: AttachmentViewerNavArrowProps): ReactNode {
  const { formatMessage } = useIntl();
  const { positionClassName, Icon } = ARROW_CONFIG[direction];

  return (
    <button
      aria-label={formatMessage({
        id: direction === 'prev' ? 'btn.previous-attachment' : 'btn.next-attachment',
      })}
      className={cx(styles.arrow, positionClassName)}
      onClick={onClick}
      type="button"
    >
      <div className={styles.arrowCircle}>
        <Icon />
      </div>
    </button>
  );
}
